import { render, staticRenderFns } from "./custom-header.vue?vue&type=template&id=2214a17c&"
import script from "./custom-header.vue?vue&type=script&lang=js&"
export * from "./custom-header.vue?vue&type=script&lang=js&"
import style0 from "./custom-header.vue?vue&type=style&index=0&id=2214a17c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports